(function ($) {
    var DEBUG_GROUP_NAME = 'equalise';
    //
    // check if debuging is allowed
    // console.log can slow down pages so only display if debug=true is in the url
    var canDebug = (location.search.indexOf('debug=true') !== -1 || location.search.indexOf('debug=' + DEBUG_GROUP_NAME) !== -1) && !!window.console && !!window.console.log;
    //
    // requestAnimationFrame shim layer with setTimeout fallback
    function requestAnimFrame() {
        return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
    }
    //
    // safe console.log
    function internalPallbackLogApply(console, arg) {
        if (typeof arg === 'object') {
            fallbackLogApply(console, arg);
        } else if (typeof arg !== 'function') {
            console.log(arg);
        }
    }
    function fallbackLogApply(console, argsCollection) {
        var i;
        if (typeof argsCollection === 'object') {
            for (i in argsCollection) {
                if (argsCollection.hasOwnProperty && argsCollection.hasOwnProperty(i)) {
                    internalPallbackLogApply(console, argsCollection[i]);
                }
            }
        } else {
            for (i = 0; i < argsCollection.length; i++) {
                internalPallbackLogApply(console, argsCollection[i]);
            }
        }
    }
    function debug() {
        if (canDebug === true && arguments.length > 0) {
            var argsArray = [].slice.call(arguments, 0);
            argsArray.unshift('::' + DEBUG_GROUP_NAME + ':: ');
            if (typeof console.log.apply === 'function') {
                console.log.apply(console, argsArray);
            } else {
                fallbackLogApply(console, argsArray);
            }
        }
    }
    debug('Loaded');
    //
    // a jQuery plugin to equalise item heights in the responsive world.
    // only siblings on the same parent and offset.top will be updated
    $.fn.equalise = function (options) {
        //
        // Default options
        var settings = $.extend({
            // possible options are padding-bottom or margin-bottom
            cssProperty: 'padding-bottom',
            triggerEvents: 'resize load equalise pluginsupdate',
            triggerElementToMonitor: window,
            // the inner element to use to calculate the heights (if empty will use the match itself)
            innerMeasurementSelector: '',
            // the inner element to adjust in order to equalise the heights (if empty will use the match itself)
            innerSelector: '',
            useOuterHeight: false,
            includeMarginsInOuterHeight: true,
            debounceMs: 1000 / 60,
            // set to false if parent grouping should be ignored
            groupByParent: true,
            // set to false if offset.top grouping should be ignores
            groupByOffsetTop: true,
            // callback called after each update
            onUpdate: undefined
        }, options);
        //
        // vars & helpers
        var max = Math.max;
        var $elements = this;
        //
        // get the element to adjust the dimension
        var getElementToAdjust = function ($el) {
            return settings.innerSelector !== '' ? $el.find(settings.innerSelector) : $el;
        };
        var removeInlineStyles = function () {
            if(typeof settings.cssProperty !== undefined && !!settings.cssProperty) {
                getElementToAdjust($elements).css(settings.cssProperty, '');
            } else {
                getElementToAdjust($elements).attr('style', '');
            }
        };
        //
        // get the height
        var getHeight = function ($el) {
            if (settings.useOuterHeight === true) {
                return $el.outerHeight(settings.includeMarginsInOuterHeight);
            } else {
                return $el.height();
            }
        };
        //
        // get the element to measure
        var getElementToMeasure = function ($el) {
            return settings.innerMeasurementSelector !== '' ? $el.find(settings.innerMeasurementSelector) : $el;
        };
        //
        // groups the items by the offset().top
        var groupByTop = function (list) {
            var topList = [];
            var groupedList = [];
            $.each(list, function (index, $el) {
                var $this = $(this);
                var top;
                //
                // only use visible elements
                if ($el.is(':visible')) {
                    //
                    // get the top
                    top = $el.position().top;
                    var topIndex = $.inArray(top, topList);
                    //
                    // if the top doesn't have a list, create one
                    if (topIndex === -1) {
                        topList.push(top);
                        topIndex = topList.length - 1;
                        groupedList[topIndex] = [];
                    }
                    groupedList[topIndex].push($this);
                }
            });
            return groupedList;
        };
        //
        // group all items by their parent
        // !! Only siblings should be equalised !!
        // !! That's as much optimisation as we can do before responsiveness stuff !!
        var groupedElements = function ($list) {
            var parentList = [];
            var groupedList = [];
            $list.each(function () {
                var $this = $(this);
                var parentElement = settings.groupByParent === false ? document.getElementsByTagName('body')[0] : $this.parent()[0];
                var parentIndex = $.inArray(parentElement, parentList);
                //
                // if the parent doesn't have a list, create one
                if (parentIndex === -1) {
                    parentList.push(parentElement);
                    parentIndex = parentList.length - 1;
                    groupedList[parentIndex] = [];
                }
                groupedList[parentIndex].push($this);
            });
            return groupedList;
        }($elements);
        var scope = this;
        //
        // Equalise the properies of the $elements
        var update = function () {
            //
            // start by removing any inline styles previously added
            // this has to be done so the natural size of each element can reset
            removeInlineStyles();
            //
            // loop through the groups and equalise
            $.each(groupedElements, function (i, listGroupedByParent) {
                if (settings.groupByParent === true) {
                    debug(listGroupedByParent.length + ' elements in parent group', listGroupedByParent);
                }
                if (listGroupedByParent.length > 1) {
                    var listGroupedByTop = settings.groupByOffsetTop === false ? [listGroupedByParent] : groupByTop(listGroupedByParent);
                    $.each(listGroupedByTop, function (j, elementList) {
                        if (settings.groupByOffsetTop === true) {
                            debug(elementList.length + ' elements with same top value', elementList);
                        }
                        if (elementList.length > 1) {
                            var maxHeight = 0;
                            //
                            // get the max height
                            $.each(elementList, function (k, $el) {
                                var $elToMeasure = getElementToMeasure($el);
                                maxHeight = max(maxHeight, getHeight($elToMeasure));
                            });
                            debug('max height calculated as ' + maxHeight);
                            //
                            // loop again a to add offsets
                            $.each(elementList, function (k, $el) {
                                var $elToChange = getElementToAdjust($el);
                                var $elToMeasure = getElementToMeasure($el);
                                var h = getHeight($elToMeasure);
                                var diff = maxHeight - h;
                                var hasNativeStyle = !!$elToChange && $elToChange[0] && typeof $elToChange[0].style[settings.cssProperty] !== 'undefined';
                                if (diff !== 0 && hasNativeStyle === true) {
                                    debug('setting element with native style(' + settings.cssProperty + ',' + diff + ')', $elToChange);
                                    $elToChange[0].style[settings.cssProperty] = diff + 'px';
                                } else if (diff !== 0 && hasNativeStyle === false) {
                                    debug('setting element with jquery css(' + settings.cssProperty + ',' + diff + ')', $elToChange);
                                    $elToChange.css(settings.cssProperty, diff + 'px');
                                }
                                if (typeof settings.onUpdate === 'function') {
                                    debug('setting element css with onUpdate callback', $elToChange);
                                    settings.onUpdate.call(scope, $elToChange, diff, settings.cssProperty, maxHeight);
                                }
                            });
                        }
                    });
                }
            });
        };
        var needsDebounced = false;
        var resizeTimeout;
        var animFrame = requestAnimFrame();
        //
        // only call if $elements exist
        if ($elements.length > 0) {
            debug('Initialised', settings);
            //
            // listen for events
            if (typeof settings.triggerEvents === 'string' && settings.triggerEvents !== '') {
                $(settings.triggerElementToMonitor).on(settings.triggerEvents, function () {
                    window.clearTimeout(resizeTimeout);
                    if (needsDebounced === true) {
                        //
                        // debounce other updates
                        resizeTimeout = window.setTimeout(function () {
                            animFrame(update);
                            needsDebounced = false;
                        }, settings.debounceMs);
                    } else {
                        //
                        // call first update immediately
                        animFrame(update);
                        needsDebounced = true;
                    }
                });
            }
            //
            // always call update at least once
            animFrame(update);
            if (typeof settings.onStart === 'function') {
                animFrame(function () {
                    settings.onStart.call(scope, $elements);
                    settings.onStart = undefined;
                });
            }
        }
        //
        // return original $elements for chaining
        return $elements;
    };
}(jQuery));